import { AccredibleButtonComponentModule } from '@accredible-frontend-v2/new-components/button';
import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  standalone: true,
  selector: 'dod-directory-list-no-results',
  templateUrl: `./directory-list-no-results.component.html`,
  styleUrls: ['./directory-list-no-results.component.scss'],
  imports: [TranslocoModule, AccredibleButtonComponentModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DirectoryListNoResultsComponent {
  onFiltersCleared = output<void>();

  clearFilters(): void {
    this.onFiltersCleared.emit();
  }
}
